import React from "react";

import OneIntelligence from "../component/OneIntelligence";
import BuildTargets from "../component/BuildTargets/BuildTargets";
import MinifiedPage from "../component/Minified/MinifiedPage";
import ReportBuilder from "../component/ReportBuilder/ReportBuilderLayout/ReportBuilder";

const Routes = () => {
  return [
    {
      path: "/",
      element: <OneIntelligence />,
      children: [
        {
          path: "/one",
          element: <MinifiedPage />
        },
        {
          path: "buildtargets",
          element: <BuildTargets />,
        },
        {
          path: "reportbuilder",
          element: <ReportBuilder />
        },
        {
          path: "advanced",
          element: <ReportBuilder />
        }
      ]
    },
    {
      path: ":creds/:marketpackage/:submarketpackage/:omcountry/:filename",
      element: <OneIntelligence />
    }
  ];
};

export default Routes;
